import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Image from "./../../elements/Image";
import { ImageAnchorTypes, ImageOverlays } from "./../../elements/Image/ImageTypes";
import getClassNameFactory from "../../utilities/classNames";

var Poster = function Poster(_ref) {
  var alignBottom = _ref.alignBottom,
      children = _ref.children,
      height = _ref.height,
      imageAnchor = _ref.imageAnchor,
      imageInlineAtNarrow = _ref.imageInlineAtNarrow,
      imageOverlay = _ref.imageOverlay,
      imageSrc = _ref.imageSrc,
      imageSrcSet = _ref.imageSrcSet,
      share = _ref.share;
  var getClassName = getClassNameFactory(Poster.displayName);
  var imageProps = {
    anchor: imageAnchor,
    overlay: imageOverlay,
    src: imageSrc,
    srcSet: imageSrcSet
  };
  var image = /*#__PURE__*/React.createElement(Image, _extends({
    alt: "",
    fit: "cover",
    sizes: Image.sizes.edgeToEdge
  }, imageProps));
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(alignBottom && "alignBottom", height)
    })
  }, imageInlineAtNarrow ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "imageWrapper"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "image"
    })
  }, imageSrc ? image : null)) : /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "image"
    })
  }, imageSrc ? image : null), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "contentInner"
    })
  }, children), share && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "share"
    })
  }, share)));
};

Poster.displayName = "Poster";
Poster.heights = ["xs", "s", "m", "l"];
Poster.propTypes = {
  /**
   * Align content to bottom of Poster
   */
  alignBottom: PropTypes.bool,

  /**
   * Markup elements or components to render on Poster (usually a single Grid)
   */
  children: PropTypes.node,

  /**
   * T-shirt-sized (minimum) height of Poster
   */
  height: PropTypes.oneOf(Poster.heights),

  /**
   * Anchor point for Poster image
   */
  imageAnchor: PropTypes.oneOf(Object.values(ImageAnchorTypes)),

  /**
   * Optionally split Poster image above the content at narrow viewport
   */
  imageInlineAtNarrow: PropTypes.bool,

  /**
   * Apply an overlay to the Poster image, e.g. a scrim gradient for text
   * legibility. Should not be used if the image has a rasterized overlay.
   */
  imageOverlay: PropTypes.oneOf(Object.values(ImageOverlays)),

  /**
   * Poster image `src`. Used if srcSet is not defined, or as a fallback.
   */
  imageSrc: PropTypes.string,

  /**
   * Comma-separated list indicating a set of possible Poster image sources
   * for the user agent to use at different screen sizes
   */
  imageSrcSet: PropTypes.string,

  /**
   * Component (i.e. SocialDropdown) for sharing the page url
   */
  share: PropTypes.node
};
export default Poster;